// Utility to generate SEO-friendly URL slugs from text

export const generateSlug = (text: string): string => {
    return text
        .toLowerCase()
        .trim()
        // Remove special characters
        .replace(/[^\w\s-]/g, '')
        // Replace spaces with hyphens
        .replace(/\s+/g, '-')
        // Replace multiple hyphens with single hyphen
        .replace(/-+/g, '-')
        // Remove leading/trailing hyphens
        .replace(/^-+|-+$/g, '');
};

export const generatePropertySlug = (
    title: string,
    location: string,
    id?: string
): string => {
    // Create a descriptive slug: "title-location"
    const slug = generateSlug(`${title} ${location}`);

    // Optionally append ID for uniqueness if needed
    return id ? `${slug}-${id.substring(0, 6)}` : slug;
};

// Example usage:
// generatePropertySlug("Affordable Room", "Arcadia, Pretoria")
// Result: "affordable-room-arcadia-pretoria"

export const extractCityFromLocation = (location: string): string => {
    // Extract city from "Suburb, City" format
    const parts = location.split(',');
    return parts.length > 1 ? parts[parts.length - 1].trim() : location.trim();
};

export const extractSuburbFromLocation = (location: string): string => {
    // Extract suburb from "Suburb, City" format
    const parts = location.split(',');
    return parts[0].trim();
};

export const normalizeLocationForURL = (location: string): string => {
    return generateSlug(location);
};
